import React from 'react'
import Faq from '../common/Faq'

const BloodTestingPanel = () => {
  return (
    <div id='website-responsive'>
        <div className='bg-img' style={{ backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2023/05/Toxicology-Testing-Middle-bg-v1.webp")', height:'100%', width:'100%'}}>
            <div className='py-2'>
                <div className='pt-md-5 pb-md-3 pt-4'>
                    <text className='fs-ss-30 text-montserrat fw-700 text-white'>
                        <center>
                            Blood Testing Panels
                        </center>
                        <div className='flex-center'>
                            <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>
                    </text>
                </div>

                <div className='pb-md-3 pb-4 pt-md-0 pt-4 px-md-5' >
                    <text className='fs-ss-16 text-montserrat text-white fw-600' style={{ letterSpacing:'0.5px'}}>
                        <center>
                        Test results are released directly into your patient software. We can deliver results for blood work in the same day,
                        <br/> less than 5 hours. Call us for blood tests anywhere in Chicago.
                        </center>
                    </text>
                </div>

                <div className='pt-'>
                    <Faq/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default BloodTestingPanel